export default function clear() {
    return "\x1b[2J\x1b[H";
}